var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0003 34.8334C27.7087 34.8334 34.8337 27.7084 34.8337 19.0001C34.8337 10.2917 27.7087 3.16675 19.0003 3.16675C10.292 3.16675 3.16699 10.2917 3.16699 19.0001C3.16699 27.7084 10.292 34.8334 19.0003 34.8334Z",
    fill: "#1A1A1A",
    fillOpacity: 0.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2705 19.0001L16.7513 23.481L25.7288 14.5193",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleBlack);
export default __webpack_public_path__ + "static/media/tick-circle-black.3157acd2a7a453ec3b5056f636272557.svg";
export { ForwardRef as ReactComponent };